"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatReviewStateByClientId = exports.getReviewerByOwner = exports.GRID_ACTIONS = exports.isUrlSourceType = exports.hasPreview = exports.uniqueNameStages = exports.isDefaultStage = exports.parseTemplateResponseStage = exports.parseRequestBodyUpdateTemplate = exports.parseRequestBodyTemplate = exports.statusStrategyTransform = exports.parseRequestBodyStage = exports.parseRoundStagesState = exports.parseCurrentRoundState = exports.parseRequestBodyRound = exports.parseRequestBodyReview = exports.formatStagesBeforeSubmit = exports.getProgressIcon = exports.getProgressSOCD = exports.filterParams = exports.isReviewUrl = exports.getIndexUrlDuplicates = exports.isUrl = exports.deadlineColorChange = exports.processingAsset = exports.defaultV3Image = exports.WHEN = exports.MANUALLY = exports.IMMEDIATELY = exports.FIRST_STAGE_INDEX = exports.DISABLED_PERMISSIONS_LABELS = exports.USER_TIMEZONE = exports.USER_NAME = exports.USER_AVATAR = exports.CATEGORY = exports.CREATE_REVIEW = exports.VIEW_DOCUMENT_REVIEW = exports.URLS = exports.REVIEWS_TEMPLATE_ADMIN_PERMISSION = exports.REVIEWS_ADMIN_PERMISSION = exports.CREATE_TEMPLATE_PERMISSION = exports.CREATE_REVIEW_PERMISSION = exports.VIEW_REVIEW_PERMISSION = exports.USER = exports.CONFIG = exports.REQUEST = void 0;
const lodash_1 = __importStar(require("lodash"));
const moment_1 = __importDefault(require("moment"));
require("moment-timezone");
const differenceInCalendarDays_1 = __importDefault(require("date-fns/fp/differenceInCalendarDays"));
const startOfDay_1 = __importDefault(require("date-fns/fp/startOfDay"));
const uuid_1 = require("uuid");
const review_stages_1 = require("./constants/review-stages");
const constants_1 = require("../reviews-modal/slice/sliceReview/constants");
const stage_settings_types_1 = require("../reviews-modal/components/ShareForReview/Overview/ReviewStage/StageSettings/stage-settings-types");
const mockData_1 = require("../reviews-modal/components/ShareForReview/Overview/ReviewStage/StageSettings/mockData");
exports.REQUEST = window.pulse.request;
exports.CONFIG = window.pulse.config;
exports.USER = window.pulse.config.user;
exports.VIEW_REVIEW_PERMISSION = exports.USER.viewReviews;
exports.CREATE_REVIEW_PERMISSION = exports.USER.createReview;
exports.CREATE_TEMPLATE_PERMISSION = exports.USER.createReviewTemplate;
exports.REVIEWS_ADMIN_PERMISSION = exports.USER.reviewsAdmin;
exports.REVIEWS_TEMPLATE_ADMIN_PERMISSION = exports.USER.reviewTemplateAdmin;
exports.URLS = exports.CONFIG.urls;
exports.VIEW_DOCUMENT_REVIEW = exports.USER.viewDocumentReviews;
exports.CREATE_REVIEW = exports.USER.createReview;
exports.CATEGORY = exports.USER.category;
exports.USER_AVATAR = `${exports.URLS.pulse}getUserProfileImage.php?id=`;
exports.USER_NAME = exports.USER.name;
exports.USER_TIMEZONE = exports.USER.timezone;
const PREVIEW_ASSET_TYPES = ['.gif'];
exports.DISABLED_PERMISSIONS_LABELS = [
    'Review Settings',
    ...(exports.CREATE_REVIEW === 'y' ? [] : ['New Review Round']),
    'Cancel Review',
];
exports.FIRST_STAGE_INDEX = 0;
exports.IMMEDIATELY = 1;
exports.MANUALLY = 2;
exports.WHEN = 3;
exports.defaultV3Image = `${exports.URLS.app_resources}images/v3/v3-default-review.png`;
exports.processingAsset = `${exports.URLS.app_resources}images/processing-ready.gif`;
const DEADLINE_COLORS = {
    default: '#959499',
    deadline: '#18181A',
    deadlineIn7Days: '#EAAC6D',
    deadlineIn3Days: '#D93A40',
};
/**
 * This function will return colour of deadline time
 * @param deadline deadline of stage/round
 * @returns color deadline
 */
const deadlineColorChange = (deadline) => {
    let deadlineColor = DEADLINE_COLORS.default;
    if (!deadline) {
        return deadlineColor;
    }
    const getCurrentDate = (0, startOfDay_1.default)(new Date());
    const convertDate = (0, startOfDay_1.default)(new Date(deadline));
    const diffDays = (0, differenceInCalendarDays_1.default)(getCurrentDate, convertDate);
    if (deadline)
        deadlineColor = DEADLINE_COLORS.deadline;
    if (diffDays <= 7)
        deadlineColor = DEADLINE_COLORS.deadlineIn7Days;
    if (diffDays <= 3)
        deadlineColor = DEADLINE_COLORS.deadlineIn3Days;
    return deadlineColor;
};
exports.deadlineColorChange = deadlineColorChange;
/**
 * This function will validate url
 * @param url
 */
const isUrl = (url) => {
    const regex = new RegExp(/\bhttps?:\/\/(?:(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)(?:\/[+~%\/.\w_-]*\??(?:[-+=&;%@.\w_]*)#?[.!\/\\\w]*)?/);
    return regex.test(url);
};
exports.isUrl = isUrl;
// export array index of urls duplicated
const getIndexUrlDuplicates = (urlsState) => {
    const indexNotDuplicate = -1;
    const indexDuplicates = urlsState.map((url, index) => urlsState.indexOf(url) !== index && url !== '' ? index : indexNotDuplicate);
    return lodash_1.default.difference(indexDuplicates, [indexNotDuplicate]);
};
exports.getIndexUrlDuplicates = getIndexUrlDuplicates;
// check is a review valid
const isReviewUrl = (validUrl) => {
    return (0, exports.isUrl)(validUrl);
};
exports.isReviewUrl = isReviewUrl;
/**
 * Change the input filter from PC to match with the endpoint
 * @param filter filter condition
 * @returns convert to the filter params
 */
const filterParams = (filter) => {
    const newParams = {};
    if (!(0, lodash_1.isEmpty)(filter)) {
        Object.keys(filter).forEach((key) => {
            if (Array.isArray(filter[key])) {
                newParams[`filter[${key}][]`] = filter[key];
            }
            else {
                newParams[`filter[${key}]`] = filter[key];
            }
        });
    }
    return newParams;
};
exports.filterParams = filterParams;
/**
 * format  progress for SOCD
 * @param Object
 * @param View
 * @return Object
 */
const getProgressSOCD = (progress, view) => {
    return {
        progressStep: progress,
        view,
    };
};
exports.getProgressSOCD = getProgressSOCD;
/**
 * get progress icon
 * @param status
 * @return string
 */
const getProgressIcon = (status) => status === review_stages_1.STAGE_STATUS.completed ? 'fal fa-check-circle' : 'fal fa-clock';
exports.getProgressIcon = getProgressIcon;
/**
 * Sync stage name with parent stage name
 * @param stages
 * @return stages
 */
const formatStagesBeforeSubmit = (stages) => {
    return stages.map((stage, index) => {
        var _a, _b;
        let parentStage = stages.find((stg) => stg.clientId === stage.parentStageId);
        if (!parentStage && stage.trigger_type_id >= exports.WHEN && index > 0) {
            parentStage = stages[index - 1];
        }
        return {
            ...stage,
            trigger_parent_stage_id: (_a = parentStage === null || parentStage === void 0 ? void 0 : parentStage.id) !== null && _a !== void 0 ? _a : null,
            trigger_parent_stage_name: (_b = parentStage === null || parentStage === void 0 ? void 0 : parentStage.name) !== null && _b !== void 0 ? _b : null,
        };
    });
};
exports.formatStagesBeforeSubmit = formatStagesBeforeSubmit;
/**
 * get request body
 * @param values
 * @return request body review
 */
const parseRequestBodyReview = (values, state) => {
    var _a, _b, _c, _d;
    return {
        data: {
            type: 'reviews',
            attributes: {
                ...values,
                review_id: state.id,
                title: state.titleReview,
                job_id: ((_a = state.project) === null || _a === void 0 ? void 0 : _a.value) || ((_c = (_b = state.project) === null || _b === void 0 ? void 0 : _b.raw) === null || _c === void 0 ? void 0 : _c.id),
                proof_owner_id: ((_d = state === null || state === void 0 ? void 0 : state.round) === null || _d === void 0 ? void 0 : _d.ownerId) || 0,
                lock_on_decisions: false,
                allow_source_download: true,
                suppress_proof_emails: false,
                instruction: state.instruction,
                notify_assigned_reviewers: state.notifyAssignedReviewer || false,
                combine: true,
                stages: (0, exports.formatStagesBeforeSubmit)(values.stages),
            },
        },
    };
};
exports.parseRequestBodyReview = parseRequestBodyReview;
/**
 * get request body
 * @param values
 * @return request body review
 */
const parseRequestBodyRound = (values, state) => {
    var _a;
    return {
        data: {
            type: 'rounds',
            id: (_a = state.round) === null || _a === void 0 ? void 0 : _a.id,
            attributes: {
                ...(0, lodash_1.omit)((0, exports.parseRequestBodyReview)(values, state).data.attributes, [
                    'job_id',
                    'review_id',
                    'combine',
                    'inputs',
                ]),
                stages: (0, exports.formatStagesBeforeSubmit)(values.stages),
            },
        },
    };
};
exports.parseRequestBodyRound = parseRequestBodyRound;
/**
 * get round state from round response
 * @param values
 * @return round (state)
 */
const parseCurrentRoundState = (roundRes) => {
    return {
        id: roundRes.id,
        title: roundRes.title,
        ownerId: roundRes.ownerId,
        ownerName: roundRes.ownerName,
        ownerAvatar: roundRes.ownerAvatar,
        roundNumber: roundRes.roundNumber,
        instruction: roundRes.instructions,
        roundType: {
            value: roundRes.roundTypeId,
            label: roundRes.roundTypeLabel,
        },
        jobId: roundRes.jobId,
        jobTitle: roundRes.jobTitle,
        round_number: roundRes.roundNumber,
        last_round_number: roundRes.lastRoundNumber,
        source: roundRes.roundSources,
        thumbnailLink: roundRes.thumbnailLink,
    };
};
exports.parseCurrentRoundState = parseCurrentRoundState;
/**
 * get round state from round response
 * @param values
 * @return round (state)
 */
const parseRoundStagesState = (stages, mode) => {
    const stageClientMap = new Map();
    stages.forEach((stage) => {
        stageClientMap.set(stage.id, (0, uuid_1.v4)());
    });
    return stages.map((stage) => {
        var _a, _b, _c, _d, _e, _f;
        const stageStatus = {
            status: mode === constants_1.MODE.newRound ? 'not_started' : stage.status,
            statusLabel: mode === constants_1.MODE.newRound ? 'Not Started' : stage.statusLabel,
        };
        if (mode === constants_1.MODE.update) {
            stageStatus.statusId = stage.statusId;
        }
        const clientId = stageClientMap.get(stage.id);
        const triggerParentStageId = (_a = stage.triggerParentStage) === null || _a === void 0 ? void 0 : _a.id;
        const parentStageId = triggerParentStageId != null
            ? (_b = stageClientMap.get(triggerParentStageId)) !== null && _b !== void 0 ? _b : undefined
            : undefined;
        return {
            clientId,
            parentStageId,
            isOpen: !(stage.status === 'completed'),
            id: stage.id,
            nameStage: stage.name,
            deadline: stage.deadline,
            triggerTypeId: (_d = (_c = stage === null || stage === void 0 ? void 0 : stage.triggerType) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : exports.IMMEDIATELY,
            triggerParentStageId: triggerParentStageId !== null && triggerParentStageId !== void 0 ? triggerParentStageId : null,
            triggerParentStageName: (_f = (_e = stage === null || stage === void 0 ? void 0 : stage.triggerParentStage) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : null,
            deadlineType: stage.deadline ? mockData_1.DEADLINE[1].value : mockData_1.DEADLINE[0].value,
            progress: mode === constants_1.MODE.update
                ? stage.progress
                : // default progress stage
                    {
                        notified: false,
                        opened: false,
                        commented: false,
                        completed: false,
                    },
            ...stageStatus,
            stageStatusStrategy: {
                type: 'stage-status-strategies',
                id: stage.statusStrategyId,
                label: stage.statusStrategyReviewerId
                    ? `Decision made by ${stage.statusStrategyReviewerName}`
                    : stage.statusStrategyLabel,
                name: stage.statusStrategyName,
                value: stage.statusStrategyId,
                statusStrategyId: stage.statusStrategyId,
                userId: stage.statusStrategyReviewerId,
            },
            members: stage.reviewers.map((reviewer) => {
                return {
                    ...reviewer,
                    share: true,
                    isWrench: true,
                    roundStageNotificationType: {
                        value: reviewer.notificationTypeId,
                        label: reviewer.notificationTypeLabel,
                    },
                };
            }),
        };
    });
};
exports.parseRoundStagesState = parseRoundStagesState;
/**
 * get request body stages of round
 * @param stages
 * @return request body stages
 */
const parseRequestBodyStage = (stages) => {
    return stages.map((stage, index) => {
        var _a, _b, _c, _d, _e, _f;
        let parentStage = stages.find((stg) => stg.clientId === stage.parentStageId);
        if (!parentStage && stage.triggerTypeId >= exports.WHEN && index > 0) {
            parentStage = stages[index - 1];
        }
        const stageObject = {
            clientId: stage.clientId,
            parentStageId: stage.parentStageId,
            name: stage.nameStage,
            status_strategy_id: (_a = stage.stageStatusStrategy) === null || _a === void 0 ? void 0 : _a.statusStrategyId,
            status_strategy_reviewer_id: ((_b = stage.stageStatusStrategy) === null || _b === void 0 ? void 0 : _b.userId) || null,
            deadline: stage.deadline
                ? (0, moment_1.default)(stage.deadline).tz(exports.USER_TIMEZONE).format()
                : stage.deadline,
            deadline_type: stage.deadlineType || null,
            reviewers: (_c = stage.members) === null || _c === void 0 ? void 0 : _c.map((member) => {
                var _a;
                const { view, comment, decision, manage } = member;
                return {
                    id: member.id || member.userid,
                    view,
                    comment,
                    decision,
                    manage,
                    notification_type_id: (_a = member.roundStageNotificationType) === null || _a === void 0 ? void 0 : _a.value,
                };
            }),
            trigger_type_id: (_d = stage === null || stage === void 0 ? void 0 : stage.triggerTypeId) !== null && _d !== void 0 ? _d : exports.IMMEDIATELY,
            trigger_parent_stage_id: (_e = parentStage === null || parentStage === void 0 ? void 0 : parentStage.id) !== null && _e !== void 0 ? _e : null,
            trigger_parent_stage_name: (_f = parentStage === null || parentStage === void 0 ? void 0 : parentStage.nameStage) !== null && _f !== void 0 ? _f : null,
        };
        if (stage.id) {
            stageObject.id = stage.id;
        }
        return stageObject;
    });
};
exports.parseRequestBodyStage = parseRequestBodyStage;
/**
 * Status strategy transform
 * @param statusStrategy
 * @return statusStrategyOptions
 */
const statusStrategyTransform = (statusStrategyOption, type = 'status-strategy') => ({
    value: statusStrategyOption === null || statusStrategyOption === void 0 ? void 0 : statusStrategyOption.id,
    label: statusStrategyOption === null || statusStrategyOption === void 0 ? void 0 : statusStrategyOption.label,
    id: statusStrategyOption === null || statusStrategyOption === void 0 ? void 0 : statusStrategyOption.id,
    userId: statusStrategyOption.userId || null,
    statusStrategyId: type === 'user'
        ? statusStrategyOption === null || statusStrategyOption === void 0 ? void 0 : statusStrategyOption.statusStrategyId
        : statusStrategyOption === null || statusStrategyOption === void 0 ? void 0 : statusStrategyOption.id,
});
exports.statusStrategyTransform = statusStrategyTransform;
const getTemplatePermission = (templatePermission, permission, resourceType) => {
    return (templatePermission.map((item) => {
        return {
            resource_type: resourceType,
            resource_id: Number(item.value),
            permission,
        };
    }) || []);
};
const parsePermissions = (templateState) => {
    const userViewPermission = getTemplatePermission(templateState.usersView, 'view', 'user');
    const userEditPermission = getTemplatePermission(templateState.usersEdit, 'edit', 'user');
    const brandViewPermission = getTemplatePermission(templateState.brandsView, 'view', 'brand');
    const officeViewPermission = getTemplatePermission(templateState.officesView, 'view', 'client');
    const brandCategoryViewPermission = getTemplatePermission(templateState.brandCategoriesView, 'view', 'brandcategory');
    return [
        ...userViewPermission,
        ...userEditPermission,
        ...brandViewPermission,
        ...officeViewPermission,
        ...brandCategoryViewPermission,
    ];
};
const parseRequestBodyTemplate = (stages, templateState) => {
    return {
        data: {
            type: 'workflow-templates',
            attributes: {
                name: templateState.templateName,
                stages: (0, exports.parseRequestBodyStage)(stages),
                permissions: parsePermissions(templateState),
            },
        },
    };
};
exports.parseRequestBodyTemplate = parseRequestBodyTemplate;
const parseRequestBodyUpdateTemplate = (id, templateState, stages) => {
    return {
        data: {
            type: 'workflow-templates',
            id,
            attributes: {
                name: templateState.templateName,
                stages: stages ? (0, exports.parseRequestBodyStage)(stages) : undefined,
                permissions: parsePermissions(templateState),
            },
        },
    };
};
exports.parseRequestBodyUpdateTemplate = parseRequestBodyUpdateTemplate;
const parseTemplateResponseStage = (stages) => {
    const stageClientMap = new Map();
    stages.forEach((stage) => {
        stageClientMap.set(stage.id, (0, uuid_1.v4)());
    });
    const roundStages = stages.map((stage) => {
        var _a, _b, _c, _d, _e;
        let deadline;
        let numberOfDay;
        switch (stage.deadlineType) {
            // no deadline
            case stage_settings_types_1.DeadlineType.noDeadline:
                deadline = null;
                break;
            // specific date
            case stage_settings_types_1.DeadlineType.specificDate:
                // specific date
                if (new Date() > new Date(stage.deadline)) {
                    // deadline is passed
                    deadline = new Date();
                    deadline.setMinutes(deadline.getMinutes() + 10);
                }
                else {
                    // deadline has not yet passed
                    deadline = new Date(stage.deadline);
                }
                break;
            // start date
            case stage_settings_types_1.DeadlineType.startDate:
                deadline = new Date();
                deadline.setMinutes(deadline.getMinutes() + 10);
                break;
            // n business day
            default:
                numberOfDay = Number(stage.deadlineType.split('_')[0]);
                deadline = new Date();
                deadline.setDate(deadline.getDate() + numberOfDay);
                break;
        }
        const clientId = stageClientMap.get(stage.id);
        const triggerParentStageId = (_a = stage.triggerParentStage) === null || _a === void 0 ? void 0 : _a.id;
        const parentStageId = triggerParentStageId != null
            ? (_b = stageClientMap.get(triggerParentStageId)) !== null && _b !== void 0 ? _b : undefined
            : undefined;
        const triggerType = (_c = stage === null || stage === void 0 ? void 0 : stage.triggerType) === null || _c === void 0 ? void 0 : _c.id;
        const roundStage = {
            clientId,
            parentStageId,
            temlateStageId: stage.id,
            isOpen: true,
            nameStage: stage.name,
            deadline: deadline
                ? (0, moment_1.default)(deadline).format('YYYY-MM-DD h:mm:ss a')
                : null,
            deadlineType: stage.deadlineType,
            stageStatusStrategy: {
                type: 'stage-status-strategies',
                id: stage.statusStrategyId,
                label: stage.statusStrategyReviewerId
                    ? `Decision made by ${stage.statusStrategyReviewerName}`
                    : stage.statusStrategyLabel,
                name: stage.statusStrategyName,
                value: `${stage.statusStrategyId}`,
                statusStrategyId: stage.statusStrategyId,
                userId: stage.statusStrategyReviewerId,
            },
            members: stage.reviewers.map((member) => {
                return {
                    id: member.id,
                    name: member.name,
                    email: member.email,
                    avatarUrl: member === null || member === void 0 ? void 0 : member.avatarUrl,
                    share: member.view,
                    view: member.view,
                    comment: member.comment,
                    decision: member.decision,
                    manage: member.manage,
                    isWrench: true,
                    progress: {
                        notified: false,
                        opened: false,
                        commented: false,
                        completed: false,
                    },
                    roundStageNotificationType: {
                        value: `${member.notificationTypeId}`,
                        label: member.notificationTypeLabel,
                    },
                };
            }),
            progress: {
                notified: false,
                opened: false,
                commented: false,
                completed: false,
            },
            status: review_stages_1.STAGE_STATUS.notStarted,
            statusLabel: 'Not started',
            triggerTypeId: triggerType !== null && triggerType !== void 0 ? triggerType : exports.IMMEDIATELY,
            triggerParentStageName: triggerType && triggerType > exports.MANUALLY
                ? (_e = (_d = stage === null || stage === void 0 ? void 0 : stage.triggerParentStage) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : null
                : null,
            triggerParentStageId: triggerType && triggerType > exports.MANUALLY
                ? triggerParentStageId !== null && triggerParentStageId !== void 0 ? triggerParentStageId : null
                : null,
        };
        return roundStage;
    });
    return roundStages;
};
exports.parseTemplateResponseStage = parseTemplateResponseStage;
// if we handle any change of stages, isDefaultStage is false
const isDefaultStage = (stages) => stages.some((stage) => stage.isDefaultStage);
exports.isDefaultStage = isDefaultStage;
/**
 * This function unique name stages
 */
const uniqueNameStages = (stages) => {
    return ((0, lodash_1.unionBy)(stages, (stage) => stage.nameStage.toLowerCase()).length !==
        stages.length);
};
exports.uniqueNameStages = uniqueNameStages;
/**
 * checking has preview for asset detail
 */
const hasPreview = (asset) => {
    const fileExtensionFromTitle = asset.title.split('.').pop() || '';
    if (PREVIEW_ASSET_TYPES.includes(fileExtensionFromTitle)) {
        return false;
    }
    return !!asset.hasPreview;
};
exports.hasPreview = hasPreview;
const isUrlSourceType = (round, currentStage, url) => {
    /**
     * stage is url if
     * - type of round source is url
     * - current stage is url
     */
    var _a;
    return !!((Array.isArray(round === null || round === void 0 ? void 0 : round.source) && ((_a = round === null || round === void 0 ? void 0 : round.source[0]) === null || _a === void 0 ? void 0 : _a.type) !== 'asset') ||
        (0, exports.isReviewUrl)(url.urls[0]) ||
        currentStage === constants_1.OPTION.url);
};
exports.isUrlSourceType = isUrlSourceType;
var GRID_ACTIONS;
(function (GRID_ACTIONS) {
    GRID_ACTIONS["READ"] = "read";
    GRID_ACTIONS["FILTER"] = "filter";
})(GRID_ACTIONS = exports.GRID_ACTIONS || (exports.GRID_ACTIONS = {}));
const getReviewerByOwner = (round, defaultNotification) => {
    var _a, _b, _c;
    return {
        id: (_a = round === null || round === void 0 ? void 0 : round.ownerId) !== null && _a !== void 0 ? _a : parseInt(exports.USER.id),
        name: (_b = round === null || round === void 0 ? void 0 : round.ownerName) !== null && _b !== void 0 ? _b : exports.USER.name,
        email: exports.USER.email,
        isWrench: true,
        progress: {
            notified: false,
            opened: false,
            commented: false,
            completed: false,
        },
        view: true,
        share: false,
        comment: true,
        decision: true,
        manage: true,
        avatarUrl: (_c = round === null || round === void 0 ? void 0 : round.ownerAvatar) !== null && _c !== void 0 ? _c : exports.USER.avatarUrl,
        roundStageNotificationType: defaultNotification,
    };
};
exports.getReviewerByOwner = getReviewerByOwner;
const formatReviewStateByClientId = (data) => {
    const stageClientMap = new Map();
    data.stages.forEach((stage) => {
        stageClientMap.set(stage.id, (0, uuid_1.v4)());
    });
    return {
        ...data,
        stages: data.stages.map((stage) => {
            var _a, _b;
            const clientId = stageClientMap.get(stage.id);
            const triggerParentStageId = (_a = stage.triggerParentStage) === null || _a === void 0 ? void 0 : _a.id;
            const parentStageId = triggerParentStageId != null
                ? (_b = stageClientMap.get(triggerParentStageId)) !== null && _b !== void 0 ? _b : undefined
                : undefined;
            return {
                ...stage,
                clientId,
                parentStageId,
            };
        }),
    };
};
exports.formatReviewStateByClientId = formatReviewStateByClientId;
